import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import dailyApi from "@/api/dailyApi";
import { homeAtom } from "./home";
import bus from "@/utils/mitt";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistSubpageApiInfoAndHeader,
} from "./utils/weatherQueryShared";

const queryDailyDetailAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));
    const resData = await dailyApi.query(newParams);
    const formattedDayList: any[] =
      resData?.data?.dayList?.map((item: any) => ({
        ...item,
        isExpand: false,
      })) || [];

    persistSubpageApiInfoAndHeader(set, resData?.data?.info);
    LocalStorage.setItem("DAILY_DETAIL", formattedDayList);
    bus.emit("DAILY_DETAIL", formattedDayList);
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { queryDailyDetailAtom };
